var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m15.383 8-5.025-5.042a.83.83 0 0 0-.591-.241.83.83 0 0 0-.592.241L4.158 8a.83.83 0 1 0 1.175 1.175l3.6-3.608V16.05c0 .459.375.834.834.834a.836.836 0 0 0 .833-.834V5.567l3.6 3.608a.82.82 0 0 0 .592.242.85.85 0 0 0 .591-.242.84.84 0 0 0 0-1.183z"
  })));
};
export default SvgArrowUp;